export default __webpack_public_path__ + "static/media/storage.c9963c7e.svg";